import { render, staticRenderFns } from "./ShowBanMem.vue?vue&type=template&id=4d5c55c4&scoped=true&"
import script from "./ShowBanMem.vue?vue&type=script&lang=js&"
export * from "./ShowBanMem.vue?vue&type=script&lang=js&"
import style0 from "./ShowBanMem.vue?vue&type=style&index=0&id=4d5c55c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c55c4",
  null
  
)

component.options.__file = "ShowBanMem.vue"
export default component.exports